/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, HostListener, PLATFORM_ID,Inject, ElementRef, ViewChild, } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { AppService } from '../../api.service';
import { DepartmentsService } from '../../services/departments.service';

@Component({
  selector: 'app-mega-menu',
  templateUrl: './mega-menu.component.html',
  styleUrls: ['./mega-menu.component.scss']
})
export class MegaMenuComponent {
   @ViewChild('scrollableDiv') scrollableDiv!: ElementRef;
  isMenuActive: boolean = false;
  isSubMenuActive: boolean = false;
  subMenu: HTMLElement | null = null;
  currentMenuTitle: string = '';
  topmenuId: any;
  showLeftButton = false;
  showRightButton = true;
  activeDepartment:any;
    constructor(@Inject(PLATFORM_ID) private platformId: object, public _as:AppService,private _ac:ActivatedRoute,public router: Router,public _ds: DepartmentsService,){
    }

  toggleMenu() {
    this.isMenuActive = !this.isMenuActive;
  }

  showSubMenu(id:any) {

    this.activeDepartment = id;
    // if (subMenu) {
      this.isSubMenuActive = true;

    // }
}

hideSubMenu() {
  this.isSubMenuActive = false;
  this.activeDepartment = undefined;

}
  scrollLeft(): void {
    const container = this.scrollableDiv.nativeElement;
    container.scrollBy({ left: -200, behavior: 'smooth' }); // Scroll left by 200px
    this.checkScroll();
  }

  scrollRight(): void {
    const container = this.scrollableDiv.nativeElement;
    container.scrollBy({ left: 200, behavior: 'smooth' }); // Scroll right by 200px
    this.checkScroll();
  }
  checkScroll(): void {
    const container = this.scrollableDiv.nativeElement;
    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    this.showLeftButton = container.scrollLeft > 0;
    this.showRightButton = container.scrollLeft < maxScrollLeft;
  }

  onTypeLink(slug:string,subCatId:any,typeId:any){
    this.topmenuId=undefined;
    const uri = 'product/'+ slug
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri],{queryParams:{subCat:subCatId,category:typeId}}));
  
  }

  closeSubMenu() {
    this.isSubMenuActive = false;
    this.activeDepartment = undefined;
}


@HostListener('document:click', ['$event'])
closeMenuOnOutsideClick(event: Event): void {
  if (this.subMenu && !this.subMenu.contains(event.target as Node)) {
    this.closeSubMenu();
  }
}
  onScrollEnlable(cat: any) {
    document.body.style.overflowY = "scroll";
    this.topmenuId = undefined;
    const uri = '/department/' + cat;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([uri]);
    });
    this.closeSubMenu(); // Close the menu after navigation
}
  
@HostListener('window:scroll', [])
onWindowScroll(): void {
  this.closeSubMenu();
}
}
